export default __webpack_public_path__ + "static/loginImg-ae059528469ea6abbba0507f262a9c27.jpg";